import { ResourceTypeAction,GiftCardTypes } from './Types'
import { ResourceInitialStateType  } from './Interface'

const intialState: ResourceInitialStateType = {
    isLoading:false, //required,
    isUserRegistered:false
}

export const giftReducer = (state=intialState,action:ResourceTypeAction) => {

    switch(action.type){
        case GiftCardTypes.LOAD_GIFTCARD:
            return { ...state, giftCard:action.payload.data,isUserRegistered:false}
        case GiftCardTypes.GIFTCARD_ERROR:
            return {...state,errors:action.payload.errors.data,isUserRegistered:false}
        case GiftCardTypes.ADD_USER:
            return {...state, giftCardUser:action.payload.data,isUserRegistered:true}
        case GiftCardTypes.LOAD_ACTIVATE_GIFTCARD:
            return {...state}
        default: return state 
    }
}


